import React from 'react';

export const DashboardSkeletonLoader: React.FC = () => {
  return (
    <div 
      style={{
        width: '100%',
        height: '100vh',
        backgroundColor: '#DCE3EE',
        display: 'flex',
        flexDirection: 'column',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }}
    >
      {/* Header Skeleton */}
      <div
        style={{
          backgroundColor: '#1e40af',
          minHeight: '60px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '16px',
          gap: '8px'
        }}
      >
        {/* Logo placeholder */}
        <div
          style={{
            width: '100px',
            height: '24px',
            backgroundColor: 'rgba(255, 255, 255, 0.3)',
            borderRadius: '4px',
            animation: 'pulse 1.5s ease-in-out infinite'
          }}
        />
        
        {/* Right side buttons */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <div
            style={{
              width: '32px',
              height: '32px',
              backgroundColor: 'rgba(255, 255, 255, 0.2)',
              borderRadius: '50%',
              animation: 'pulse 1.5s ease-in-out infinite'
            }}
          />
          <div
            style={{
              width: '80px',
              height: '32px',
              backgroundColor: 'rgba(255, 255, 255, 0.2)',
              borderRadius: '4px',
              animation: 'pulse 1.5s ease-in-out infinite'
            }}
          />
          <div
            style={{
              width: '32px',
              height: '32px',
              backgroundColor: 'rgba(255, 255, 255, 0.2)',
              borderRadius: '50%',
              animation: 'pulse 1.5s ease-in-out infinite'
            }}
          />
        </div>
      </div>

      {/* Body Skeleton */}
      <div
        style={{
          flex: 1,
          padding: '24px',
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
          overflow: 'auto'
        }}
      >
        {/* Title skeleton */}
        <div>
          <div
            style={{
              width: '200px',
              height: '24px',
              backgroundColor: '#e5e7eb',
              borderRadius: '4px',
              marginBottom: '8px',
              animation: 'pulse 1.5s ease-in-out infinite'
            }}
          />
          <div
            style={{
              width: '300px',
              height: '16px',
              backgroundColor: '#f3f4f6',
              borderRadius: '4px',
              animation: 'pulse 1.5s ease-in-out infinite'
            }}
          />
        </div>

        {/* Card skeletons */}
        {[1, 2, 3].map((i) => (
          <div
            key={i}
            style={{
              backgroundColor: 'white',
              borderRadius: '8px',
              padding: '20px',
              boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
            }}
          >
            <div
              style={{
                width: '150px',
                height: '20px',
                backgroundColor: '#e5e7eb',
                borderRadius: '4px',
                marginBottom: '12px',
                animation: 'pulse 1.5s ease-in-out infinite'
              }}
            />
            <div
              style={{
                width: '100%',
                height: '16px',
                backgroundColor: '#f3f4f6',
                borderRadius: '4px',
                marginBottom: '8px',
                animation: 'pulse 1.5s ease-in-out infinite'
              }}
            />
            <div
              style={{
                width: '80%',
                height: '16px',
                backgroundColor: '#f3f4f6',
                borderRadius: '4px',
                animation: 'pulse 1.5s ease-in-out infinite'
              }}
            />
          </div>
        ))}

        {/* Analyzing state skeleton */}
        <div
          style={{
            backgroundColor: 'white',
            borderRadius: '8px',
            padding: '40px',
            textAlign: 'center',
            marginTop: '20px'
          }}
        >
          <div
            style={{
              width: '64px',
              height: '64px',
              backgroundColor: '#dbeafe',
              borderRadius: '50%',
              margin: '0 auto 16px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              animation: 'pulse 1.5s ease-in-out infinite'
            }}
          >
            <div
              style={{
                width: '32px',
                height: '32px',
                backgroundColor: '#93c5fd',
                borderRadius: '50%'
              }}
            />
          </div>
          <div
            style={{
              width: '120px',
              height: '20px',
              backgroundColor: '#e5e7eb',
              borderRadius: '4px',
              margin: '0 auto',
              animation: 'pulse 1.5s ease-in-out infinite'
            }}
          />
        </div>
      </div>

      {/* Footer Skeleton */}
      <div
        style={{
          minHeight: '40px',
          backgroundColor: '#f9fafb',
          borderTop: '1px solid #e5e7eb',
          padding: '12px 16px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <div
          style={{
            width: '100px',
            height: '16px',
            backgroundColor: '#e5e7eb',
            borderRadius: '4px',
            animation: 'pulse 1.5s ease-in-out infinite'
          }}
        />
      </div>

      {/* CSS Animation */}
      <style>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
      `}</style>
    </div>
  );
};

